/* businesses */
export const CREATE_EVENT = "CREATE_EVENT"
export const CREATE_EVENT_SUCCESS = "CREATE_EVENT_SUCCESS"
export const CREATE_EVENT_ERROR = "CREATE_EVENT_ERROR"
export const CREATE_EVENT_CLEAN = "CREATE_EVENT_CLEAN"
